module.exports = __webpack_public_path__ + "static/media/Autos-green-svg.e525f4bd.svg";